export const DEV_SCENARIO_ACTIVE_KEY = "pleasurai-dev-scenario-active"

export function isDevScenarioActive(): boolean {
  if (process.env.NODE_ENV !== "development") return false
  if (typeof window === "undefined") return false
  return window.localStorage.getItem(DEV_SCENARIO_ACTIVE_KEY) === "true"
}
